(function ($, Unison) {
  'use strict';

  Drupal.behaviors.artistry_videos_formatter_v1 = {
    attach: function (context) {
      // ids and classes we can refer to
      // data-filter-id - set on the form options
      // <option data-filter-id="mac--all" value="mac--all">All Videos</option>
      // <option data-filter-id="video-cat-term1" value="video-cat-term1">Face</option>
      // media-block - on the artist element that also has one of the classes below
      // 'mac--all' => 'All Videos', // used as a label only
      // 'video-cat-term1' => 'Face',
      // 'video-cat-term2' => 'Eyes',
      // 'video-cat-term3' => 'Lips',

      var $videoTile = $('.media-block--video', context), // there are many
        $filterDropdown = $('select.js-video-filter'),
        $filterList = $('ul.js-video-filter'),
        $sectionHead = $('.artistry-video-section__header'),
        $sectionFoot = $('.artistry-video-section__footer'),
        $viewAllAnchorTag = $('.js-artistry-videos-view-all');

      $filterDropdown.on('change', function (e) {
        var filterClass = $(this).val();

        filterApply(filterClass);
      });

      $filterList.on('change', function (e) {
        var filterClass = $(this).val();

        filterApply(filterClass);
      });

      function getDropdownValueFromURLHash(hash) {
        var dropdownValue = '';

        switch (hash) {
          case 'face':
            dropdownValue = 'video-cat-term1';
            break;
          case 'eyes':
            dropdownValue = 'video-cat-term2';
            break;
          case 'lips':
            dropdownValue = 'video-cat-term3';
            break;
          default:
            dropdownValue = 'mac--all';
        }

        return dropdownValue;
      }

      $filterList.find('.sec-nav__sub-link').on('click', function (e) {
        e.preventDefault();
        var filterClass = $(this).attr('data-id');

        $filterDropdown.val(filterClass);
        filterApply(filterClass);
        $filterList.find('.sec-nav__link span').html($(this).html());
      });
      $('.js-sec-nav_item-has-sub-nav').on('keydown', function (e) {
        var $this = $(this);
        var expanded = $this.attr('aria-expanded');
        var $dropdownOptions = $this.find('.js-sec-nav-sub-nav');
        var keyCode = site.getKeycode(e);

        if (expanded === 'false' && keyCode === 13) {
          $dropdownOptions.addClass('shades-dropdown-visibility');
          $this.attr('aria-expanded', 'true');
        } else if (expanded === 'true' && (keyCode === 13 || keyCode === 27)) {
          $dropdownOptions.removeClass('shades-dropdown-visibility');
          $this.attr('aria-expanded', 'false');
        }
      });
      $filterList.find('.sec-nav__sub-link').on('keydown', function (e) {
        e.preventDefault();
        var keyCode = site.getKeycode(e);
        var $parent = $(this).parent();

        $(this).removeClass('custom-outline');
        switch (keyCode) {
          case 40:
            $parent.next().find('.sec-nav__sub-link').addClass('custom-outline').focus();
            break;
          case 38:
            $parent.prev().find('.sec-nav__sub-link').addClass('custom-outline').focus();
            break;
          case 13:
            $(this).trigger('click');
            $('.js-sec-nav_item-has-sub-nav').focus();
            break;
          case 27:
            $(this).parents('.js-sec-nav-sub-nav').removeClass('shades-dropdown-visibility');
            break;
        }
      });

      if (window.location.hash != '') {
        var urlHash = window.location.hash.substr(1, window.location.hash.length - 1);
        var dropdownValue = getDropdownValueFromURLHash(urlHash);

        $filterDropdown.val(dropdownValue);
        $('li [data-id=' + dropdownValue + ']').click();
      }

      function filterApply(filterClass) {
        var dropdownText = $filterDropdown.children('option[value=' + $filterDropdown.val() + ']').text().toLowerCase();

        if (dropdownText != 'all videos' && dropdownText != 'filter by') {
          window.location.hash = dropdownText;
        } else {
          window.location.hash = '';
        }

        if (filterClass === 'mac--all') {
          $videoTile.closest('.grid--item').fadeIn('500');
          $sectionHead.fadeIn('500');
          $sectionFoot.fadeIn('500');
        } else {
          $('.media-block--video.' + filterClass).closest('.grid--item').fadeIn('500');
          $sectionHead.fadeOut('500');
          $sectionFoot.fadeOut('500');
          $videoTile.not('.media-block--video.' + filterClass).closest('.grid--item').fadeOut('500');
        }
      }

      // The view all option has been removed from the filter dropdown
      // Instead there is simply a link underneath the dropdown now.
      $viewAllAnchorTag.on('click', function (e) {
        e.preventDefault();
        $videoTile.closest('.grid--item').fadeIn('500');
        $sectionHead.fadeIn('500');
        $sectionFoot.fadeIn('500');
      });

      var $filterContainer = $('.artistry-videos__filter-container', context);
      var $sectionStacks = $('.artistry-videos__content--section-stacks', context);
      var insertLocation = '.artistry-video-section:eq(0)';

      // When using stacks, wrap the video section grid items
      // and change the insert location for the video filter
      if ($sectionStacks.length > 0) {
        $('.grid--item', $sectionStacks).wrapAll('<div class="artistry-video-section responsive-container"><div class="artistry-video-section__grid"></div></div>');
        insertLocation = '.artistry-video-section:eq(0) .grid--item:eq(0)';
      }
      // Move the video filter based on breakpoint
      Unison.on('change', function (bp) {
        var bpWidth = parseInt(bp.width, 10);
        var usnLarge = parseInt(Unison.fetch.all()['usn-large'], 10);

        if (bpWidth < usnLarge) {
          $filterContainer.detach().insertBefore($(insertLocation, context));
        } else {
          $filterContainer.detach();
          $('.artistry-videos__formatter', context).prepend($filterContainer);
        }
      });
    } // attach
  };
})(jQuery, Unison);
